import { NgModule } from '@angular/core';
import { NgxHorizontalTimelineComponent } from './ngx-horizontal-timeline.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [NgxHorizontalTimelineComponent],
  imports: [
    CommonModule
  ],
  exports: [NgxHorizontalTimelineComponent]
})
export class NgxHorizontalTimelineModule { }
